import React, { useEffect } from 'react';
import { X, CheckCircle, XCircle, AlertTriangle, Info } from 'lucide-react';
import './Toast.css';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

export interface ToastProps {
    id: string;
    message: string;
    type: ToastType;
    onClose: (id: string) => void;
}

const icons = {
    success: <CheckCircle size={20} />,
    error: <XCircle size={20} />,
    warning: <AlertTriangle size={20} />,
    info: <Info size={20} />,
};

const Toast: React.FC<ToastProps> = ({ id, message, type, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose(id);
        }, 3000); // Auto close after 3s

        return () => clearTimeout(timer);
    }, [id, onClose]);

    return (
        <div className={`toast toast-${type}`}>
            <div className="toast-icon">
                {icons[type]}
            </div>
            <span className="toast-message">{message}</span>
            <button className="toast-close" onClick={() => onClose(id)}>
                <X size={16} />
            </button>
        </div>
    );
};

export default Toast;
